<template>
  <div>
    <div class="bespoke">
      <!-- BESPOKE BANNER -->
      <div class="bespoke">
        <div class="bread">
          <p v-html="'HOME &nbsp; / &nbsp; BESPOKE'"></p>
        </div>
        <div class="bespoke_banner">
          <img class="mobileimg" :src="bannerBgMobile" alt="">
          <img class="bigimg" :src="bannerBg" alt="">
          <div class="banner_text">
            <h2>MAKE IT BE BESPOKE</h2>
            <p>Custom pieces made just how you want them.</p>
          </div>

        </div>
        <div class="textzone">
          <h6>EMMA LEE Offers A Range Of Bespoke Services.
          From Engagement Rings And Friendship Bracelets To Corporate Gifting</h6>
          <div class="text_down">
            <h3>LET THE CREATIVE JUICES FLOW</h3>
            <span></span>
            <p>For more information or to book a bespoke consultation please email: <b>shop@emmalee.com</b>
            and we will get back to you as soon as possible.</p>
          </div>
        </div>
          <!-- MIDDLE PIC -->
        <div class="middle_pic slider single-item">
          <img class="pic01" :src="middlepic01" alt="">
          <img class="pic02" :src="middlepic02" alt="">
          <img class="pic03" :src="middlepic03" alt="">
        </div>
        <div class="middle_pic_pc">
          <img class="pic01" :src="middlepic01" alt="">
          <img class="pic02" :src="middlepic02" alt="">
          <img class="pic03" :src="middlepic03" alt="">
        </div>

        <!-- CLIENT -->
        <div class="client">
            <h3>CLIENTS TESTIMONIAL</h3>
            <div class="client_img">
              <img class="client" :src="client" alt="">
              <img class="ring" :src="ring" alt="">
            </div>
            <div class="less_text">
            <p>A 1 carat family heirloom stone set in a wide gold band with a halo of diamonds around it.</p>
            </div>
            <div class="more_text">
            <p>A 1 carat family heirloom stone set in a wide gold band with a halo of diamonds around it. Made modern by sparkling baguette diamonds on either side.</p>
            </div>
            <h6>A modern update on an etruscan classic style</h6>
        </div>
        <h5></h5>
        <div class="down_email">
          <p>For bespoke enquiries, please get in touch.</p>
          <a href="#">
          <b>Email: shop@emmalee.com</b>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bannerBgMobile from '@/assets/pc/bespoke/banner_bg_mobile.jpg'
import bannerBg from '@/assets/pc/bespoke/banner_bg.jpg'
import middlepic01 from '@/assets/pc/bespoke/middlepic01.jpg'
import middlepic02 from '@/assets/pc/bespoke/middlepic02.jpg'
import middlepic03 from '@/assets/pc/bespoke/middlepic03.jpg'
import client from '@/assets/pc/bespoke/client.jpg'
import ring from '@/assets/pc/bespoke/ring.png'

export default {
  data () {
    return {
      bannerBgMobile,
      bannerBg,
      middlepic01,
      middlepic02,
      middlepic03,
      client,
      ring
    }
  }
}
</script>
